'use client'

import Link from 'next/link'

import Image from 'next/image'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import { useUIStore } from '@/stores/uiStore'

const MoreDropdown = () => {
  const selectedUsaha = useUIStore(state => state.selectedUsaha)
  const isSamco = selectedUsaha === 'SDP'
  const logoSrc = isSamco ? '/images/icon/logo_icon_white_samco.png' : '/images/icon/logo_m_white.png'
  const logoAlt = isSamco ? 'PT SAMCO DWI PERKASA' : 'RS TMC'
  const titleText = isSamco ? 'PT SAMCO DWI PERKASA' : 'RS TMC'
  const subTitleText = isSamco ? 'SAMCO Report' : 'TMC Report'

  return (
    <Link href='/' style={{ textDecoration: 'none' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <Box
          sx={{
            display: 'grid',
            placeItems: 'center',
            width: 32,
            height: 32,
            borderRadius: '50%',
            backgroundColor: 'primary.main',
            color: 'primary.contrastText'
          }}
        >
          <Image src={logoSrc} alt={logoAlt} width={20} height={20} priority style={{ objectFit: 'contain' }} />
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', lineHeight: 1 }}>
          <Typography variant='subtitle1' sx={{ fontWeight: 700, color: 'text.primary' }}>
            {titleText}
          </Typography>
          <Typography variant='caption' sx={{ fontWeight: 600, color: 'text.secondary', letterSpacing: 0.2 }}>
            {subTitleText}
          </Typography>
        </Box>
      </Box>
    </Link>
  )
}

export default MoreDropdown
